import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from 'core/services/auth.service';
import { EMPTY, finalize, ReplaySubject, takeUntil } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NzModalModule, NzModalRef } from 'ng-zorro-antd/modal';
import { CustomMessageService } from 'core/services/custom-message.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { KorviuLoaderComponent } from 'shared/components/korviu-loader/korviu-loader.component';
import { KorviuInputComponent } from 'shared/components/korviu-input/korviu-input.component';
import { KorviuButtonComponent } from 'shared/components/korviu-button/korviu-button.component';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrl: './delete-account.component.scss',
  standalone: true,
  imports: [KorviuLoaderComponent, KorviuInputComponent, TranslateModule, KorviuButtonComponent, NzModalModule]
})
export class DeleteAccountComponent implements OnInit, OnDestroy {
  public passwordControl: FormControl;
  public isLoading: boolean;
  public isPasswordCorrect: boolean;

  private readonly _onDestroy$: ReplaySubject<void>;

  constructor(
    private _authService: AuthService,
    private _modal: NzModalRef,
    private _messageService: CustomMessageService,
    private _translateService: TranslateService
  ) {
    this.isLoading = false;
    this.passwordControl = new FormControl('', [Validators.required]);
    this.isPasswordCorrect = true;
    this._onDestroy$ = new ReplaySubject<void>(1);
  }

  public ngOnInit(): void {
    this.passwordControl.valueChanges.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
      this.isPasswordCorrect = true;
    });
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  public onDeleteClick(): void {
    if (this.isLoading || this.passwordControl.invalid) {
      return;
    }
    this.isLoading = true;
    this._authService
      .deleteAccount(this.passwordControl?.value || '')
      .pipe(
        finalize(() => {
          this.isLoading = false;
        }),
        catchError(() => {
          this.isPasswordCorrect = false;
          this.passwordControl.setErrors({ incorrect: true });
          return EMPTY;
        }),
        takeUntil(this._onDestroy$)
      )
      .subscribe(() => {
        this._messageService.success(this._translateService.instant('profile.accountSuccessfullyDeleted'));
        this._modal.close();
      });
  }
}
